module.exports = __webpack_public_path__ + "static/media/4.1a47f1bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/4.png
// module id = 1228
// module chunks = 0